// extracted by css-extract-rspack-plugin
export default {"universeBackground":"UniverseBackground-module__universeBackground__xS8Xl"};